import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import _Select from "../../../generic/_Select";
import { RangeDate } from "../RangeDate";
import dayjs from "dayjs";


const PERIOD_OPTIONS = [
  { value: "0", label: "Hoy" },
  { value: "1", label: "Últimas 24 horas" },
  { value: "2", label: "Última semana" },
  { value: "3", label: "Este mes" },
  { value: "4", label: "Últimos 30 días" },
  { value: "5", label: "Personalizar" },
];

const DateFilters = (props) => {
  const { setFilterFrom, setFilterTo, required, errors, isClean } = props;
  const [selectRange, setSelectRange] = useState("0");
  const [isVisible, setIsVisible] = useState(false);
  const [values, setValues] = useState({
    dateFrom: dayjs().format("YYYY-MM-DD"),
    dateTo: dayjs().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    getFilters();
  }, [selectRange, values]);

  const getFilters = () => {
    let dateFrom, dateTo;
    const today = new Date();

    switch (selectRange) {
      case "0": // Hoy
        dateFrom = new Date(today.setHours(0, 0, 0, 0));
        dateTo = new Date();
        break;
      case "1": // Últimas 24 horas
        dateFrom = new Date(Date.now() - 24 * 60 * 60 * 1000);
        dateTo = new Date();
        break;
      case "2": // Última semana
        dateFrom = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        dateTo = new Date();
        break;
      case "3": // Este mes
        dateFrom = new Date(today.getFullYear(), today.getMonth(), 1);
        dateTo = new Date();
        break;
      case "4": // Últimos 30 días
        dateFrom = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
        dateTo = new Date();
        break;
      case "5": // Personalizar
        dateFrom = new Date(values.dateFrom);
        dateTo = new Date(values.dateTo);
        break;
      default:
        dateFrom = new Date(today.setHours(0, 0, 0, 0));
        dateTo = new Date();
        break;
    }

    const formattedFrom = dateFrom
      .toISOString()
      .split("T")[0]
      .replace("/-/", "/");
    const formattedTo = dateTo.toISOString().split("T")[0].replace("/-/", "/");

    setFilterFrom(formattedFrom);
    setFilterTo(formattedTo);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!isVisible) {
      setSelectRange("0");
    }
  }, [isVisible]);

  useEffect(() => {
    if (selectRange === "5") {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [selectRange]);

  useEffect(() => {
    if (isClean) {
      _onClean();
    }
  }, [isClean]);

  const _onClean = () => {
    setSelectRange("0");
    setIsVisible(false);
  };

  return (
    <div className="flex justify-start gap-2 items-center mb-4 w-full">
      <div className="w-full flex flex-col">
        <_Select
          title="Periodo"
          options={PERIOD_OPTIONS}
          value={selectRange}
          onChange={(e) => setSelectRange(e.target.value)}
          id="datePeriod"
          name="datePeriod"
          required={required}
        />

        {selectRange === "5" && isVisible ? (
          <RangeDate
            onChange={handleChange}
            dateFrom={values.dateFrom}
            dateTo={values.dateTo}
            errors={errors}
            required={required}
          />
        ) : null}
      </div>
    </div>
  );
};

DateFilters.propTypes = {
  setFilterFrom: PropTypes.func.isRequired,
  setFilterTo: PropTypes.func.isRequired,
  required: PropTypes.bool,
  errors: PropTypes.object,
  isClean: PropTypes.bool,
};

export default DateFilters;
